import { Trans } from '@lingui/react/macro'
import { ChevronRight, ChevronLeft } from 'lucide-react'
import { Button } from '@components/v2/button'

interface Props {
  page: number
  limit?: number
  total?: number
  onNextClick: () => void
  onPreviousClick: () => void
  nextCursor: string | undefined
  isPreviousAvailable: boolean
}

const getPageItems = (limit: number, page: number, total = 0) => {
  const start = (page - 1) * limit + 1
  const end = Math.min(page * limit, total)

  return { start, end, text: `${start}-${end}` }
}

export const Pagination = ({
  limit = 0,
  page,
  total,
  onNextClick,
  onPreviousClick,
  nextCursor,
  isPreviousAvailable,
}: Props) => {
  const { text } = getPageItems(limit, page, total)

  return (
    <div className="flex justify-between items-center w-full py-4">
      <div className="flex-[1]">
        {!!total && (
          <span className="text-cv-slate-800 text-xs2">
            <Trans>
              Showing {text} of {total} translations
            </Trans>
          </span>
        )}
      </div>
      <div className="flex gap-4">
        <Button variant="text" onClick={onPreviousClick} disabled={!isPreviousAvailable}>
          <div className="flex items-center gap-1">
            <ChevronLeft />
            <Trans>Previous</Trans>
          </div>
        </Button>
        <Button variant="text" onClick={onNextClick} disabled={!nextCursor}>
          <div className="flex items-center gap-1">
            <Trans>Next</Trans>
            <ChevronRight />
          </div>
        </Button>
      </div>
    </div>
  )
}
